import { YDatabase } from '@databases/collab/y-database';
import { Properties, YFieldType } from '@databases/collab/y-field';
import * as Y from 'yjs';

import { getCloudIdFromServerId } from '@canvas/atlassian-service/datasource/migration';

/**
 * Pulls out template ID from a nested object into the string property
 */
export async function migrateJiraServerId(_documentId: string, ydb: YDatabase) {
  for (const fieldId of ydb.fields) {
    const field = ydb.fieldsById[fieldId];
    const fieldMap = field.unwrap();
    if (
      fieldMap instanceof Y.Map &&
      fieldMap.get(Properties.type) === YFieldType.JIRA_ISSUE &&
      fieldMap.get(Properties.settingJiraServerId) &&
      !fieldMap.get(Properties.settingCloudId)
    ) {
      const cloudId = await getCloudIdFromServerId(
        fieldMap.get(Properties.settingJiraServerId)
      );
      ydb.mutate((db) => {
        const field = db.fieldsById[fieldId];
        field.cloudId = cloudId;
      });
    }
  }
}
